import { ProjectViewState } from 'src/modules/project-view/types/ProjectViewState';
import { RootState } from 'src/types/RootState';

export function getProjectViewState(state: RootState): ProjectViewState {
  return state.projectView;
}
